"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.authRefreshWatcher = authRefreshWatcher;

var _effects = require("redux-saga/effects");

var actions = _interopRequireWildcard(require("./actions"));

var authActions = _interopRequireWildcard(require("../../auth/actions"));

var types = _interopRequireWildcard(require("./types"));

var _apiRequest = require("../api/apiRequest");

var _selectors = require("../../auth/selectors");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(authRefreshWorker),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(authRefreshWatcher);

function authRefreshWorker() {
  var authState, auth;
  return regeneratorRuntime.wrap(function authRefreshWorker$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return (0, _effects.put)(actions.start());

        case 3:
          _context.next = 5;
          return (0, _effects.select)(_selectors.getAuthState);

        case 5:
          authState = _context.sent;
          _context.next = 8;
          return (0, _effects.call)(_apiRequest.apiRequest, "auth/refresh", "POST", {
            body: authState,
            auth: false
          });

        case 8:
          auth = _context.sent;

          if (auth) {
            _context.next = 14;
            break;
          }

          _context.next = 12;
          return (0, _effects.put)(actions.failure());

        case 12:
          _context.next = 20;
          break;

        case 14:
          _context.next = 16;
          return (0, _effects.put)(authActions.auth(auth));

        case 16:
          _context.next = 18;
          return (0, _effects.put)((0, authActions.tokenTimeoutCheckerSaga)());

        case 18:
          _context.next = 20;
          return (0, _effects.put)(actions.success());

        case 20:
          _context.next = 29;
          break;

        case 22:
          _context.prev = 22;
          _context.t0 = _context["catch"](0);
          console.error(_context.t0);
          _context.next = 27;
          return (0, _effects.put)(authActions.unauthorizeSaga());

        case 27:
          _context.next = 29;
          return (0, _effects.put)(actions.failure());

        case 29:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[0, 22]]);
}

function authRefreshWatcher() {
  return regeneratorRuntime.wrap(function authRefreshWatcher$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.takeEvery)(types.SAGA, authRefreshWorker);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}